import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { IProductData } from 'interfaces/IProductData';
import { cartService } from 'services/CartService';
import Translate from 'components/Translate';
import FeeInstallments from './feeInstallment';
import FeeSubscription from './feeSubscription';
import { enPaymentType } from 'enums/enPaymentType';
import { WithStyles } from 'shared/decorators/withStyles';

interface IState extends IStateBase {
  cart: IProductData;
}

interface IProps {
  hiddenFeeInstallments?: boolean;
}

@WithStyles(() => ({
  component: {
    textAlign: 'center',
    display: 'block',
    bottom: 0,
    left: 0,
    right: 0,
    fontSize: '0.75rem',
    color: 'black',
    textShadow: '1px 1px 2px #fff',

    '@media screen and (max-width: 960px)': {
      justifyContent: 'center'
    },

    '& a': {
      '&:after': {
        content: '"|"',
        display: 'inline-block',
        margin: '0 5px'
      },

      '&:last-child:after': {
        content: '""'
      }
    }
  }
}))
export default class Footer extends BaseComponent<IState, IProps> {
  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { cart } = this.state;

    return (
      <div className={`${this.props.classes.component} chk-media-footer`}>
        {!this.props.hiddenFeeInstallments && <FeeInstallments />}
        {cart.config.paymentType === enPaymentType.SUBSCRIPTION && <FeeSubscription />}
        &nbsp;
        <span className='chk-footer-links'>
          <a href="https://eduzz.com/privacidade" target="_blank" rel="noopener noreferrer">
            <Translate term="Política de privacidade" />
          </a>
          <a href="https://eduzz.com/termos" target="_blank" rel="noopener noreferrer">
            <Translate term="Termos de compra" />
          </a>
          {cart.config.affiliateId !== 0 && (
            <a target="_blank" rel="noopener noreferrer">
              REF: {cart.config.affiliateId}
            </a>
          )}
        </span>
      </div>
    );
  }
}
